import request from '@/utils/request';
export function messageList(data) {
  return request.post('admin/message/center/list', data);
}
export function messageDetail(data) {
  return request.post('admin/message/center/detail', data);
}
export function messagePopList(data) {
  return request.post('admin/message/pop-list', data);
}
export function forceReaderingMessageList(data) {
  return request.post('admin/message/forced-reading/list', data);
}
export function streamInfo(data) {
  return request.post('upload/stream', data);
}
export function readAllMessage(data) {
  return request.post('admin/message/status/all-read', data);
}